module.exports = __webpack_public_path__ + "03_medium_gold.6b60b773.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_medium_gold.png
// module id = lngb
// module chunks = 0